import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Form, Formik } from 'formik';

import Button from '@components/smartAdminUI/Button';
import FormikField from '@components/form/FormikField';
import { trim } from 'lodash';

const AgentAdvancedSearch = ({ onSubmitClicked }) => {
  const agentSearchLoading = useSelector(state => state.agent.searchLoading);

  const buildWhereClause = values => {
    const whereClause = {
      clause: [],
    };
    const valueKeys = Object.keys(values);

    whereClause.clause = valueKeys.map(key => {
      if (values[key]) {
        return {
          name: key,
          value: trim(values[key]),
        };
      }
      return null;
    });

    whereClause.clause = whereClause.clause.filter(el => el !== null);

    return whereClause;
  };

  const handleSubmit = values => {
    const whereClause = buildWhereClause(values);
    const jsonBody = {
      action: 'search',
      where: whereClause,
    };

    onSubmitClicked(jsonBody);
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        MemberMlsId: '',
        MemberFirstName: '',
        MemberLastName: '',
      }}
    >
      {({ handleReset }) => (
        <Form className="col">
          <div className="form-row form-group">
            <div className="col-md-4 mb-1">
              <FormikField
                datatype="string"
                fieldLabel="Agent ID"
                FieldName="MemberMlsId"
                inputType="TextInput"
                maxLength={50}
                IsVisible
              />
            </div>
            <div className="col-md-4 mb-1">
              <FormikField
                datatype="string"
                fieldLabel="Last Name"
                FieldName="MemberLastName"
                inputType="TextInput"
                maxLength={50}
                IsVisible
              />
            </div>
            <div className="col-md-4 mb-1">
              <FormikField
                datatype="string"
                fieldLabel="First Name"
                FieldName="MemberFirstName"
                inputType="TextInput"
                maxLength={50}
                IsVisible
              />
            </div>
            <div className="col-md-4 mb-1">
              <FormikField
                datatype="string"
                fieldLabel="Status"
                FieldName="MemberStatus"
                inputType="ComboBox"
                comboBoxLookupName="Lookup_Agent_Agent_MemberStatus"
                IsVisible
              />
            </div>
          </div>
          <Button
            name="btnSearchAgent"
            variant="primary"
            type="submit"
          >
            {agentSearchLoading
              ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                  Searching...
                </>
              ) : (
                <>
                  <i className="fas fa-search mr-2" aria-hidden="true" />
                  Search
                </>
              )}
          </Button>
          <Button
            name="btnSearchAgentClear"
            onClick={handleReset}
            variant="primary"
          >
            <i className="fas fa-times mr-2" />
            Clear
          </Button>
        </Form>
      )}
    </Formik>
  );
};

AgentAdvancedSearch.propTypes = {
  onSubmitClicked: PropTypes.func,
};

export default AgentAdvancedSearch;
